<template>
  <div id="quickly-warranty">
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: "ApeH5",
    data () { return {} },
    methods: {},
    created () {}
  }
</script>
<style lang="less">
  @import "./style/gb.less";
  html,
  body {
    font-size: 16px;
  }
  @media screen and (min-width: 320px) {
    html,
    body {
      font-size: 13px;
    }
  }
  @media screen and (min-width: 375px) {
    html,
    body {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 414px) {
    html,
    body {
      font-size: 15px;
    }
  }
  @media screen and (min-width: 540px) {
    html,
    body {
      font-size: 16px;
    }
  }
  #quickly-warranty {
    width: 100vw;
    height: 100vh;
    line-height: 1.5;
    color: #333;
    -webkit-text-size-adjust: 100% !important;
    -webkit-font-smoothing: antialiased;
    font-family: PingFang SC, Arial, Helvetica, STHeiti STXihei, Microsoft YaHei,
      Tohoma, sans-serif;
    overflow: hidden auto;
    box-sizing: border-box;
  }
  .safe-area-top {
    padding-top: constant(safe-area-inset-top); //为导航栏+状态栏的高度 88px
    padding-top: env(safe-area-inset-top); //为导航栏+状态栏的高度 88px
  }
  .safe-area-left {
    padding-left: constant(safe-area-inset-left); //如果未竖屏时为0
    padding-left: env(safe-area-inset-left); //如果未竖屏时为0
  }
  .safe-area-right {
    padding-right: constant(safe-area-inset-right); //如果未竖屏时为0
    padding-right: env(safe-area-inset-right); //如果未竖屏时为0
  }
  .safe-area-bottom {
    padding-bottom: constant(safe-area-inset-bottom); //为底下圆弧的高度 34px
    padding-bottom: env(safe-area-inset-bottom); //为底下圆弧的高度 34px
  }
</style>
